import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReconstructedInterventionReportComponent} from './intervention-report.component';
import {DxPopupModule, DxTabsModule, DxButtonModule, DxFormModule, DxTextAreaModule, DxNumberBoxModule, DxSelectBoxModule} from 'devextreme-angular';
import {LeafletModule} from '@asymmetrik/ngx-leaflet';
import {TimePieChartModule} from '../../reports/charts/time-pie-chart/time-pie-chart.module';
import {MapLayersControlModule} from '../../map/map-layers-control/map-layers-control.module';
import {BadgeModule} from 'shared';
import {DialogsModule} from '../dialogs.module';


@NgModule({
  declarations: [ReconstructedInterventionReportComponent],
  imports: [
    CommonModule,
    DxPopupModule,
    DxButtonModule,
    DxFormModule,
    DxTextAreaModule,
    DxNumberBoxModule,
    DxSelectBoxModule,
    LeafletModule,
    TimePieChartModule,
    DxTabsModule,
    MapLayersControlModule,
    BadgeModule,
    DialogsModule,
  ],
  exports: [ReconstructedInterventionReportComponent]
})
export class ReconstructedInterventionReportModule {
}

